<template>
  <div class="voiceEvalResults">
    <div class="mask"></div>
    <div class="light"></div>
    <div class="cssFn_show content">
      <div class="close" @click="close"></div>
      <div class="top">
        <p class="close_hint">{{intervalNum}}秒后关闭</p>
        <div class="score"><span>{{voiceEvalData.score}}</span><i>得分</i></div>
        <div class="describe">{{voiceEvalData.conclusion}}</div>
      </div>
      <div class="bottom">
        <div v-if="voiceEvalData.isWord==1" class="box">
          <ul>
            <li>完整度</li>
            <li
              v-for="i in 5"
              :key="i"
              :style="{ 'animation-delay': Math.ceil(voiceEvalData.completion)  == i? (1000 + i * 100)-400 + 'ms' : 1000 + i * 100 + 'ms' }"
              :class="{ 'scale' : Math.ceil(voiceEvalData.completion)  == i }"
            >
              <img
                src="../../../assets/img/voice_eval_results/star2.png"
                alt=""
              />
              <img
                src="../../../assets/img/voice_eval_results/star1.png"
                alt=""
                v-if="voiceEvalData.completion>=i"
              />
              <img
                v-if="voiceEvalData.completion.includes('.')? Math.ceil(voiceEvalData.completion)==i:false"
                src="../../../assets/img/voice_eval_results/star3.png"
                alt=""
              />
            </li>
          </ul>
          <ul>
            <li>流畅度</li>
            <li
              v-for="i in 5"
              :key="i"
              :style="{ 'animation-delay': Math.ceil(voiceEvalData.fluency)  == i ? (1500 + i * 100)-400 + 'ms' : 1500  + i * 100 + 'ms' }"
              :class="{ 'scale':  Math.ceil(voiceEvalData.fluency)  == i }"
            >
              <img
                src="../../../assets/img/voice_eval_results/star2.png"
                alt=""
              />
              <img
                src="../../../assets/img/voice_eval_results/star1.png"
                alt=""
                v-if="voiceEvalData.fluency>=i"
              />
              <img
                v-if="voiceEvalData.fluency.includes('.')? Math.ceil(voiceEvalData.fluency)==i:false"
                src="../../../assets/img/voice_eval_results/star3.png"
                alt=""
              />
            </li>
          </ul>
          <ul>
            <li>准确度</li>
            <li
              v-for="i in 5"
              :key="i"
              :style="{ 'animation-delay':  Math.ceil(voiceEvalData.fullness)  == i ? (2000 + i * 100)-400 + 'ms' : 2000  + i * 100 + 'ms' }"
              :class="{ 'scale': Math.ceil(voiceEvalData.fullness)  == i }"
            >
              <img
                src="../../../assets/img/voice_eval_results/star2.png"
                alt=""
              />
              <img
                src="../../../assets/img/voice_eval_results/star1.png"
                alt=""
                v-if="voiceEvalData.fullness>=i"
              />
              <img
                v-if="voiceEvalData.fullness.includes('.')? Math.ceil(voiceEvalData.fullness)==i:false"
                src="../../../assets/img/voice_eval_results/star3.png"
                alt=""
              />
            </li>
          </ul>

        </div>
        <div class="box" v-else>
          <ol>
            <li v-show="false"></li>
            <li
              v-for="i in 5"
              :key="i"
              :style="{ 'animation-delay': i === Math.ceil(voiceEvalData.star) ? (1000 + 100 * i) - 400 + 'ms' : 1000 + 100 * i + 'ms' }"
              :class="{ scale:  Math.ceil(voiceEvalData.star)==i}"
            >
              <img
                src="../../../assets/img/voice_eval_results/star2.png"
                alt=""
              />
              <img
                src="../../../assets/img/voice_eval_results/star1.png"
                alt=""
                v-if="voiceEvalData.star>=i"
              />
              <img
                src="../../../assets/img/voice_eval_results/star3.png"
                alt=""
                v-if="voiceEvalData.star.includes('.')? Math.ceil(voiceEvalData.star)==i:false"
              />
            </li>
          </ol>
        </div>

        <div class="tip">
          <div class="add mr35" v-if="voiceEvalData.coin">
            <div class="icon"></div>
            <div class="addcoin">+{{voiceEvalData.coin}}</div>
          </div>
          <div class="add " v-if="voiceEvalData.teamScore">
            <div class="dian"></div>
            <div class="addcoin adddian">+{{voiceEvalData.teamScore}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "voiceEvalResults",
  data() {
    return {
      interval:null,
      intervalNum:5
    };
  },
  props: {
    voiceEvalData:{
      required:true,
      type:Object
    }
  },
  mounted() {
    setTimeout(this.countDown,1000)
  },
  methods: {
    filterStar(){
      if(val.includes('.')){
        let i = val.split('.')[0];
        return
      }
    },
    countDown(){
      this.interval = setInterval(()=>{
        if(this.intervalNum<=1){
          clearInterval(this.interval);
          this.close();
          return;
        }
        this.intervalNum--;
      },1000)
    },
    close() {
      this.$emit("close");
    }
  },
  beforeDestroy(){
    clearInterval(this.interval);
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.voiceEvalResults {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 80;
  display: flex;
  justify-content: center;
  align-items: center;
  .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
  }
  .light {
    width: 490px;
    height: 490px;
    animation: bounceIn 0.4s 0.2s ease both, rotateMotivate 18s infinite linear;
    transform-origin: 50% 50%;
    background: url("../../../assets/img/voice_eval_results/light.png")
      no-repeat;
    background-size: cover;
    position: absolute;
    top: 50%;
    margin-top: -300px;
  }
  .cssFn_show {
    animation: bounceIn 0.4s 0.2s ease both;
    -webkit-animation: bounceIn 0.5s 0.2s ease both;
  }
  .cssFn_hide {
    animation: bounceOut 0.5s 0.2s ease both;
    -webkit-animation: bounceOut 0.5s 0.2s ease both;
  }
  .close {
    background: url("../../../assets/img/video/ranking_close.png") no-repeat;
    position: absolute;
    top: -42px;
    right: -42px;
    width: 42px;
    height: 42px;
    z-index: 90;
    background-size: 100%;
    cursor: pointer;
  }
  .content {
    width: 450px;
    height: auto;
    background: #ffffff;
    border-radius: 15px;
    position: relative;
  }
  .top {
    width: 100%;
    height: 145px;
    background: url("../../../assets/img/voice_eval_results/top_bg.png") no-repeat;
    background-size: cover;
  }
  .score{
    width: 177px;
    height: 170px;
    background: url("../../../assets/img/voice_eval_results/sun.png") no-repeat;
    background-size: cover;
    margin: -70px auto 0;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    span{
      margin-top: -20px;
      font-size: 54px;
      height: 60px;
    }
    i{
      font-size: 18px;
    }
  }
  .describe{
    position: absolute;
    width: 390px;
    height: 90px;
    background: url("../../../assets/img/voice_eval_results/describe.png") no-repeat;
    background-size: cover;
    left: 30px;
    top:84px;
    font-size: 24px;
    font-weight: 600;
    color: #bd5a00;
    line-height: 60px;
  }
  .close_hint {
    text-align: right;
    padding: 15px 15px 0 0;
    color: #ffffff;
    font-size: 14px;
  }
  .box {
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: left;
    margin: 20px 0;
  }
  ul,ol {
    display: flex;
    margin-top: 10px;
    li {
      position: relative;
      width: 37px;
      height: 37px;
      opacity: 0.6;
      transform: scale(0);
      animation: scale1 100ms cubic-bezier(0.745, 0, 0.31, 0.995) both;
      transform-origin: 50% 50%;
      margin-right: 5px;
      &:first-child {
        height: 37px;
        line-height: 37px;
        width: 90px;
        font-size: 20px;
        color: #333333;
        visibility: visible;
        transform: scale(1);
        animation: none;
      }
    }
    .scale {
      animation: scale2 800ms 0s cubic-bezier(0.745, 0, 0.31, 0.995) both;
      transform: scale(1);
      opacity: 1;
    }
    img {
      width: 100%;
      position: absolute;
    }
  }
  ul{
    animation: ulshow 1ms both;
    visibility: hidden;
    &:nth-child(1){
      animation-delay:1000ms
    }
    &:nth-child(2){
      animation-delay:1500ms
    }
    &:nth-child(3){
      animation-delay:2000ms
    }
  }
  ol{
    margin: 40px 0 30px 0;
  }
  .tip {
    width: 308px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    line-height: 45px;
    background: rgba(0,195,230, 0.08);
    border-radius: 22px;
    color: #BB6700;
    font-weight: 600;
    margin: 27px auto;
    font-size: 22px;
    .add{
      display: flex;
      align-items: center;
      line-height: 22px;
      .icon{
        width: 30px;
        height: 30px;
        background: url(../../../assets/img/common/coin.png) no-repeat;
        background-size: cover;
      }
      .dian{
        width: 30px;
        height: 30px;
        background: url(../../../assets/img/common/energy.png) no-repeat;
        background-size: cover;
      }
      .addcoin{
        margin-left: 7px;
      }
      .adddian{
        color: #008c66;
      }
    }
    .mr35{
      margin-right: 35px;
    }
  }
}
@media screen and (max-height: 640px){
  .voiceEvalResults {
    margin-top: 15px;
  }
}
@keyframes ulshow {
  0% {
    visibility: hidden;
  }

  100% {
    visibility: visible;
  }
}
@keyframes scale1 {
  0% {
    opacity:0;
    transform: scale(0.5);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes scale2 {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  25% {
    transform: scale(1.3);
  }
  50% {
    transform: scale(0.8);
  }
  75% {
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/voiceEvalResults.vue